import { createContext } from 'react';
export const ApiContext = createContext({
  providers: [],
  administrators: [],
  offices: [],
  centers: [],
  whyNyga: [],
  homeInfo: null,
  webinars: [],
  isLoading: false,
  services: [],
  conditions: [],
  research: [],
});
